import { getProperty } from 'customer-data-objects/record/ObjectRecordAccessors';
import isLegacyHubSpotObject from 'customer-data-objects/crmObject/isLegacyHubSpotObject';
// see Slack Thread for why this lives here: https://git.hubteam.com/HubSpot/crm-events/issues/2293
export function getCreateDate(record, objectType) {
  const createDatePropertyName = isLegacyHubSpotObject(objectType) ? 'createdate' : 'hs_createdate';
  return getProperty(record, createDatePropertyName);
}